import React from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';

import CategoriesNav from './component';

const CategoriesNavContainer = (props) => {
  const { selectedLocale, ...otherProps } = props;
  return <CategoriesNav {...otherProps} locale={selectedLocale} />;
};

CategoriesNavContainer.propTypes = {
  selectedLocale: PropTypes.string,
};

CategoriesNavContainer.defaultProps = {
  selectedLocale: undefined,
};

export default withRouter(CategoriesNavContainer);
